import { useParams } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { PluginBilling } from '@/components/plugins/PluginBilling';
import type { PluginManifest } from '@/types';

/**
 * Speed Booster — paid image-optimization add-on. Not an installed plugin, so we
 * render the shared reseller billing UI (plan cards + subscribe/cancel) against a
 * synthetic, Tyashin-billed manifest. The backend handles `speed-booster` as a
 * platform-internal add-on through the same /plugins/.../{plans,subscribe,cancel}
 * routes, flipping the per-project image-optimization entitlement.
 */
const SPEED_BOOSTER_MANIFEST = {
  id: 'speed-booster',
  name: 'Speed Booster',
  description:
    'Automatically resize and convert every storefront image to next-gen formats (AVIF/WebP), adapted to each visitor’s device and connection — typically 90%+ smaller. Faster pages, better Core Web Vitals, higher conversion.',
  pricing: { billingManagedBy: 'tyashin' },
} as unknown as PluginManifest;

export default function SpeedBoosterPage() {
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <div className="mx-auto max-w-5xl space-y-6 p-6">
      <header className="flex items-start gap-3">
        <div className="bg-primary/10 text-primary flex h-11 w-11 items-center justify-center rounded-xl">
          <Zap className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Speed Booster</h1>
          <p className="text-muted-foreground mt-1 max-w-2xl text-sm">
            {SPEED_BOOSTER_MANIFEST.description}
          </p>
        </div>
      </header>

      {projectId && (
        <PluginBilling
          manifest={SPEED_BOOSTER_MANIFEST}
          projectId={projectId}
          pluginId="speed-booster"
          productType="addon"
        />
      )}
    </div>
  );
}
